import Mock from 'mockjs'
import _ from 'lodash'
import { baseUrl } from '@/utils/global'
import * as authc from './modules/authc'
import * as template from './modules/template'

// 1. 开启/关闭[所有模块]拦截, 通过调[openMock参数]设置.
// 2. 开启/关闭[业务模块]拦截, 通过调用fnCreate方法[isOpen参数]设置.
// 3. 开启/关闭[业务模块中某个请求]拦截, 通过函数返回对象中的[isOpen属性]设置.

let openMock = true
fnCreate(authc, openMock)
fnCreate(template, openMock)

/**
 * 创建mock模拟数据
 * @param {*} mod 模块
 * @param {*} isOpen 是否开启?
 */
function fnCreate(mod, isOpen = true) {
  if (isOpen) {
    for (var key in mod) {
      ((res) => {
        if (res.isOpen !== false) {
          let url = baseUrl
          if (!_.endsWith(url, '/')) {
            url = url + '/'
          }
          url = url + res.url
          Mock.mock(new RegExp(url), res.method, (opts) => {
            opts.data = opts.body ? JSON.parse(opts.body) : null
            delete opts.body
            console.log('\n')
            console.log('%cmock拦截, 请求: ', 'color:blue', opts)
            let data = typeof res.data === "function" ? res.data(opts) : res.data
            console.log('%cmock拦截, 响应: ', 'color:blue', data)
            return data
          })
        }
      })(mod[key]() || {})
    }
  }
}



// WEBPACK FOOTER //
// ./src/mock/index.js